import {logger} from '#/logger'

export type ContactSyncData = {
  email: string
  handle: string
  did: string
}

export type ContactSyncResponse = {
  success: boolean
  message?: string
  id?: string
  updated?: boolean
}

const API_ENDPOINT = `${process.env.EXPO_PUBLIC_API_URL || 'https://api.grapevyne.space'}/api/contacts/sync`

/**
 * Syncs a user contact to Resend
 * This is a fire-and-forget operation - failures are logged but don't throw
 */
export async function syncContactToResend(
  data: ContactSyncData,
): Promise<ContactSyncResponse> {
  try {
    logger.debug('Syncing contact to Resend', {
      handle: data.handle,
      did: data.did.substring(0, 20) + '...',
    })

    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({
        message: 'Failed to sync contact',
      }))
      logger.warn('Failed to sync contact to Resend', {
        status: response.status,
        error: errorData.message,
      })
      return {
        success: false,
        message: errorData.message || 'Failed to sync contact',
      }
    }

    const result = await response.json()
    logger.debug('Contact synced to Resend', {
      success: result.success,
      updated: result.updated,
    })

    return {
      success: true,
      message: result.message,
      id: result.data?.id,
      updated: result.updated,
    }
  } catch (error) {
    logger.warn('Error syncing contact to Resend', {
      error: error instanceof Error ? error.message : 'Unknown error',
    })
    return {
      success: false,
      message:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    }
  }
}
